import Layout from '@layout/Index'

export const banquetTask = [
  {
    path: '/banquet-task',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'records',
      },
      {
        path: 'records',
        component: () => import(/* webpackChunkName: "banquet-task-records" */ './pages/BanquetTaskRecordTable.vue'),
        name: '宴席任务',
        meta: {
          title: '宴席任务',
          activeMenu: '/banquet-task/records',
        },
      },
      {
        path: 'records/:id',
        component: () => import(/* webpackChunkName: "banquet-task-record-detail" */ './pages/BanquetTaskRecordDetail.vue'),
        name: '宴席任务详情',
        meta: {
          title: '宴席任务详情',
          activeMenu: '/banquet-task/records',
        },
      },
      {
        path: 'batch',
        component: () => import(/* webpackChunkName: "banquet-task-batch" */ './pages/BanquetTaskBatchTable.vue'),
        name: '宴席批量导入',
        meta: {
          title: '宴席批量导入',
          activeMenu: '/banquet-task/batch',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/banquet-task/banquet-task.route.js